import styled from "@emotion/styled";
import { PRIMARY_BLACK, LIGHT_FONT } from "src/constants/colors";

export const BannerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
  padding: 0 24px;
  border-radius: 16px;
  background: ${PRIMARY_BLACK};
  overflow: hidden;
  position: relative;
`;

export const BannerText = styled.div`
  color: ${LIGHT_FONT};
  font-size: 14px;
`;

export const IllustrationContainer = styled.div`
  position: absolute;
  right: 0;
  top: 0;
`;
